import * as React from 'react';

import { Text } from '../../atoms/text';
import { ThemeConsumer } from '../../atoms/theme';
import { Card } from 'ui';

export class SegmentedControl extends React.Component {
  getProperty = (label, property) => {
    if (typeof label === 'object') {
      return label[property];
    }
    return label;
  };

  onChange = (label) => {
    this.props.onChange(typeof label === 'object' ? label.value : label);
  };

  render() {
    const { labels, selectedLabel } = this.props;
    return (
      <ThemeConsumer>
        {(theme) => (
          <Card shrinked className="segment" id={this.props.id}>
            {labels.map((label, idx, arr) => {
              return (
                <button
                  id={label.id}
                  key={idx}
                  onClick={() => this.onChange(label)}
                  className={`segment__button ${selectedLabel === this.getProperty(label, 'value') ? 'active' : null}`}
                  style={{
                    borderColor: selectedLabel === this.getProperty(label, 'value') ? theme.color.brand : 'transparent',
                  }}
                >
                  <Text
                    size={15}
                    color={selectedLabel === this.getProperty(label, 'value') ? theme.color.brand : '#90a4ae'}
                  >
                    {this.getProperty(label, 'title')}
                  </Text>
                </button>
              );
            })}
          </Card>
        )}
      </ThemeConsumer>
    );
  }
}
